import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location?: string;
  product?: string;
  text: string;
  accent?: 'blue' | 'green' | 'gold';
};
const accents: Record<NonNullable<TestimonialProps['accent']>, string> = {
  blue: 'bg-blue-900',
  green: 'bg-emerald-800',
  gold: 'bg-amber-700'
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text,
  accent = 'blue'
}: TestimonialProps) {
  const meta = [location, product].filter(Boolean).join(' — ');
  return <article className="flex h-full flex-col rounded-2xl border border-l-4 border-slate-200 border-l-blue-700 bg-white p-6 shadow-sm md:p-8" data-id="element-295" data-mp="2x09vir763e52">
      <div className="mb-4 flex items-center" data-id="element-296" data-mp="2s39reltvolgl">
        <div className={`mr-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white md:text-lg ${accents[accent]}`} data-id="element-297" data-mp="v96ijv9t1nhc">
          {initials}
        </div>
        <div data-id="element-298" data-mp="h5y8adksjb33">
          <div className="mb-1 flex text-amber-400" data-id="element-299" data-mp="h5f1nt0lc94d">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" data-id="element-300" data-mp="m62p64pm27tu" />)}
          </div>
          <p className="font-semibold text-slate-900 md:text-lg" data-id="element-301" data-mp="78aepqyx89mi">{name}</p>
          {meta && <p className="text-xs text-slate-500 md:text-sm" data-id="element-302" data-mp="c6ll1rq0c1zz">{meta}</p>}
        </div>
      </div>
      <p className="flex-grow text-sm italic leading-relaxed text-slate-700 md:text-base" data-id="element-303" data-mp="zwg08fxsu2ne">“{text}”</p>
    </article>;
}
const testimonials: TestimonialProps[] = [{
  initials: 'MV',
  name: 'M.V.',
  product: 'Holistic Practitioner',
  accent: 'blue',
  text: 'For the first time, I have a complete system for my sessions. Clients notice the difference from the very beginning, and when I use the visual map to organise the areas we are exploring, they feel they are working with a truly prepared professional.'
}, {
  initials: 'CL',
  name: 'C.L.',
  product: 'Practitioner',
  accent: 'green',
  text: 'Volume III alone was worth the entire kit for me. Before, I did not know how to close sessions with a clear structure. Now I can offer concrete integration exercises and work with much more clarity in my practice.'
}, {
  initials: 'SM',
  name: 'S.M.',
  product: 'Practitioner in Training',
  accent: 'gold',
  text: 'I was just getting started, and the Kit gave me the structure I needed from my very first session. The focused questions help me organise the exploration of emotional context without going blank. I arrived at my practice with more confidence from day one.'
}];
export function InitialTestimonials() {
  return <Section className="pb-14 pt-6" data-id="element-304" data-mp="14sjwgh1fmn4j">
      <div className="mx-auto max-w-3xl" data-id="element-305" data-mp="14tle54cye7v8">
        <h2 className="mb-6 text-center text-sm font-bold uppercase tracking-[.18em] text-amber-700" data-id="element-306" data-mp="10s9tld8xsctw">
          What practitioners say
        </h2>
        <TestimonialCard {...testimonials[0]} data-id="element-307" data-mp="vrvkrszigyut" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-308" data-mp="qvn7ym8sdhqt">
      <div className="mb-10 text-center" data-id="element-309" data-mp="32hfglgh7m8j2">
        <h2 className="text-2xl font-bold text-blue-900 md:text-4xl" data-id="element-310" data-mp="32gntyv5lbl4x">
          ❤️ WHAT PRACTITIONERS SAY
        </h2>
      </div>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-3" data-id="element-311" data-mp="3cf3l2y4mauef">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-312" data-mp="3ggf58o4q2nf8" />)}
      </div>
    </Section>;
}